import React, { useEffect, useState } from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';
import Header from '../../../common/header/header';
import {
  baseUrl,
  facebooksocialicon,
  instagramsocialicon,
  linkedin_social_icon,
  share_social_icon,
  twittersocialicon,
} from '../../../api/baseUrl';
import { useCookies } from 'react-cookie';
import LoadingImage from '../../../assets/media/loader.gif';
import { useDisclosure } from '@mantine/hooks';
import { Button, Modal } from '@mantine/core';

const MediaDetail = () => {
  const { title } = useParams();
  const location = useLocation();
  const [item, setItem] = useState(location.state?.item || null);
  const [modelActive, setModelActive] = useState('');
  const [currentVideo, setCurrentVideo] = useState('');
  const [opened, setOpened] = useState(false);
  // const [mediaopened, { open, setMediaOpened, close }] = useDisclosure(false);
  const [mediaopened, setMediaOpened] = useState(false);
  const [isCopying, setIsCopying] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(!location.state?.item);
  const [result, setResult] = useState([]);
  const [cookies] = useCookies();
  const [visibleItems, setVisibleItems] = useState(10);
  const close = () => setMediaOpened(false);
  const loadMoreItems = () => {
    setVisibleItems((prev) => prev + 4);
  };
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    setLoading(true);
    fetch(`${baseUrl}/media/analystbriefing`, {
      headers: {
        Authorization: `Bearer ${cookies?.accessToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setFilteredData(data);
        setResult(data);
        const matchedItem = data.find(
          (d) =>
            d.title
              ?.toLowerCase()
              .replace(/\s+/g, '-')
              .replace(/[^a-z0-9-]/g, '') === title
        );
        setItem(matchedItem || null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [title, cookies.accessToken]);

  const handleOpenModal = (videoUrl) => {
    setCurrentVideo(videoUrl);
    setOpened(true);
  };

  const handleCopyUrl = async (url) => {
    try {
      setIsCopying(true);
      await navigator.clipboard.writeText(url);
      setTimeout(() => setIsCopying(false), 1000);
    } catch (error) {
      console.error('Copy failed:', error);
      setIsCopying(false);
    }
  };

  return (
    <>
      <Header />
      <div className="media-detail-page">
        <div className="container">
          <div className="media-grid-sec corporate-boxes">
            <div className="row">
              <div className="col-md-8">
                <div className="video-container media-video-container">
                  <iframe
                    src={item ? `${item.url}?autoplay=1` : ''}
                    // title={item.title}
                    frameBorder="0"
                    allow="autoplay; fullscreen"
                    allowFullScreen
                    className="media-video-iframe"
                    width="100%"
                    height="532px"
                  ></iframe>
                  <ul className="media-social-bottom">
                    {item && (
                      <h1 className="media-detail-heading p-0">{item.title}</h1>
                    )}
                    <li
                      onClick={() => {
                        setModelActive(item);
                        setMediaOpened(true);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: share_social_icon,
                        }}
                      />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4">
                {filteredData.slice(0, 2).map((item, index) => (
                  <div className="items_box media-detail-sec mb-3" key={index}>
                    <Link
                      to={{
                        pathname: `/media/analystbriefing/${item.title
                          .toLowerCase()
                          .replace(/\s+/g, '-')
                          .replace(/[^a-z0-9-]/g, '')}`,
                        state: { item: item },
                      }}
                      onClick={(e) => {
                        setItem(item);
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }}
                    >
                      <img
                        src={item.thumbnail}
                        alt=""
                        className="luckbox1_img thumnail-image"
                        style={{ cursor: 'pointer' }}
                      />
                    </Link>
                    <div className="card-body p-0 media-brefing-video">
                      <h5 className="luckheldtext media-detail-head p-0">
                        <Link
                          to={{
                            pathname: `/media/analystbriefing/${item.title
                              .toLowerCase()
                              .replace(/\s+/g, '-')
                              .replace(/[^a-z0-9-]/g, '')}`,
                            state: { item: item },
                          }}
                          onClick={(e) => {
                            setItem(item);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        >
                          {item.title}
                        </Link>
                      </h5>
                      <ul className="corporate-underlist">
                        <li>{item.date2}</li>
                        <li
                          onClick={() => {
                            setModelActive(item);
                            setMediaOpened(true);
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html: share_social_icon,
                            }}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {filteredData.length > 3 && (
              <div className="media-detail-boxed">
                <div className="row">
                  {filteredData.slice(3, visibleItems).map((item, index) => (
                    <div className="col-md-3">
                      <div
                        className="items_box media-detail-sec mb-3"
                        key={index}
                      >
                        <Link
                          to={{
                            pathname: `/media/analystbriefing/${item.title
                              .toLowerCase()
                              .replace(/\s+/g, '-')
                              .replace(/[^a-z0-9-]/g, '')}`,
                            state: { item: item },
                          }}
                          onClick={(e) => {
                            setItem(item);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        >
                          <img
                            src={item.thumbnail}
                            alt=""
                            className="luckbox1_img thumnail-image"
                            style={{ cursor: 'pointer' }}
                          />
                        </Link>
                        <div className="card-body p-0 media-brefing-video">
                          <h5 className="luckheldtext p-0">
                            <Link
                              to={{
                                pathname: `/media/analystbriefing/${item.title
                                  .toLowerCase()
                                  .replace(/\s+/g, '-')
                                  .replace(/[^a-z0-9-]/g, '')}`,
                                state: { item: item },
                              }}
                              onClick={(e) => {
                                setItem(item);
                                window.scrollTo({
                                  top: 0,
                                  behavior: 'smooth',
                                });
                              }}
                            >
                              {item.title}
                            </Link>
                          </h5>
                          <ul className="corporate-underlist">
                            <li>{item.date2}</li>
                            <li
                              onClick={() => {
                                setModelActive(item);
                                setMediaOpened(true);
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: share_social_icon,
                                }}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {filteredData.length > visibleItems && (
                  <div className="text-center mt-3">
                    <Button
                      onClick={loadMoreItems}
                      className="mt-3 mb-3 analyst-media-btn"
                    >
                      Load More
                    </Button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        opened={mediaopened}
        onClose={close}
        title="Share With"
        centered
        size="30rem"
        padding="md"
        classNames={{ header: 'text-center' }}
      >
        {/* Your Modal Content */}
        <div className="social-icons text-center space-y-2">
          <a
            href={`http://www.facebook.com/sharer/sharer.php?u=${modelActive.url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              className="social-txt-head"
              dangerouslySetInnerHTML={{
                __html: facebooksocialicon,
              }}
            />
            Facebook
          </a>
          <a
            href={`https://twitter.com/intent/tweet?url=${modelActive.url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              className="social-txt-head"
              dangerouslySetInnerHTML={{
                __html: twittersocialicon,
              }}
            />
            Twitter
          </a>
          <a
            href={`https://www.instagram.com/?url=${modelActive.url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              className="social-txt-head"
              dangerouslySetInnerHTML={{
                __html: instagramsocialicon,
              }}
            />
            Instagram
          </a>
          <a
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${modelActive.url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              className="social-txt-head"
              dangerouslySetInnerHTML={{
                __html: linkedin_social_icon,
              }}
            />
            LinkedIn
          </a>
        </div>
        <div class="share-link-txt">
          <h1>Or share with link</h1>
        </div>
        <div className="field">
          <input type="text" readOnly value={modelActive.url} />
          <Button onClick={() => handleCopyUrl(modelActive.url)}>
            {isCopying ? 'Copied...' : 'Copy'}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default MediaDetail;
